module.exports = __webpack_public_path__ + "static/img/offline.9ef0e8f3.jpg";